import { lazy, Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { LoadingSpinner } from './components/ui/loading-states'
import './App.css'

// Два независимых чанка: админ-панель (сайдбар, все разделы) и мобильный
// раздел обучения для WebView. Мобилке не нужен код админки — и наоборот.
const AdminRoutes = lazy(() => import('./AdminRoutes'))
const LearnApp = lazy(() => import('./learn/LearnApp'))

function ChunkFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <LoadingSpinner size="lg" />
    </div>
  )
}

function App() {
  return (
    <Suspense fallback={<ChunkFallback />}>
      <Routes>
        <Route path="/learn/*" element={<LearnApp />} />
        <Route path="/*" element={<AdminRoutes />} />
      </Routes>
    </Suspense>
  )
}

export default App
